import React from 'react';

const Card = ({ title, count, icon, colour }) => {
    return (
        <div className="card" style={{ backgroundColor: colour }}>
            <img className="card-icon" src={icon} />
            <div className="card-text">
                <h3>{title}</h3>
                <p>{count}</p>
            </div>
        </div>
    );
};

export default Card;